import axios from 'axios';

export const state = {};

export const getters = {};

export const mutations = {};

export const actions = {
    async index() {
        const { data } = await axios.get('/file-categories/');

        return data;
    },

    async show(vuexContext, id) {
        const { data } = await axios.get(`/file-categories/${id}`);

        return data;
    },

    async store(vuexContext, category) {
        const { data } = await axios.post('/file-categories', category);

        return data;
    },

    async update(vuexContext, { id, categoryData }) {
        const { data } = await axios.put(
            `/file-categories/${id}`,
            categoryData
        );

        return data;
    },

    async destroy(vuexContext, category) {
        const { data } = await axios.delete(
            `/file-categories/${category.id}`
        );

        return data;
    },

    async addFile(vuexContext, { categoryId, file }) {
        const { data } = await axios.post(
            `/file-categories/${categoryId}/file`,
            file
        );

        return data;
    },

    async deleteFile(vuexContext, id) {
        const { data } = await axios.delete(`/file-categories/files/${id}`);

        return data;
    }
};
